<template>
  <v-container fluid class="ma-0 pa-0">
    <v-row v-if="weatherData != null" align="center" justify="center" dense>
      <v-col cols="3" :class="textSize">23&deg;C</v-col>
      <v-col cols="6">
        <v-row align="center" justify="center" dense>
          <v-col cols="5" align="right">
            <v-icon v-if="weatherData.windDirection === 'NORTHERLY'" :size="iconSize" class="pb-1">mdi-arrow-down-bold-outline</v-icon>
            <v-icon v-if="weatherData.windDirection === 'SOUTHERLY'" :size="iconSize" class="pb-1">mdi-arrow-up-bold-outline</v-icon>
            <v-icon v-if="weatherData.windDirection === 'WESTERLY'" :size="iconSize" class="pb-1">mdi-arrow-right-bold-outline</v-icon>
            <v-icon v-if="weatherData.windDirection === 'EASTERLY'" :size="iconSize" class="pb-1">mdi-arrow-left-bold-outline</v-icon>
            <v-icon v-if="weatherData.windDirection === 'NORTH_WESTERLY'" :size="iconSize" class="pb-1">mdi-arrow-bottom-right-bold-outline</v-icon>
            <v-icon v-if="weatherData.windDirection === 'NORTH_EASTERLY'" :size="iconSize" class="pb-1">mdi-arrow-bottom-left-bold-outline</v-icon>
            <v-icon v-if="weatherData.windDirection === 'SOUTH_WESTERLY'" :size="iconSize" class="pb-1">mdi-arrow-top-right-bold-outline</v-icon>
            <v-icon v-if="weatherData.windDirection === 'SOUTH_EASTERLY'" :size="iconSize" class="pb-1">mdi-arrow-top-left-bold-outline</v-icon>
          </v-col>
          <v-col cols="7" :class="textSize">{{ weatherData.windForce }} bft</v-col>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-layout row justify-center>
          <div v-if="dateTimeIsNight">
            <v-icon v-if="weatherData.visibility === 'GOOD'" :size="iconSize" class="pb-1">mdi-weather-night</v-icon>
            <v-icon v-if="weatherData.visibility === 'MODERATE' || weatherData.visibility === 'FOG'" :size="iconSize" class="pb-1">mdi-weather-night-partly-cloudy</v-icon>
          </div>
          <div v-else>
            <v-icon v-if="weatherData.visibility === 'GOOD'" color="yellow" :size="iconSize" class="pb-1">mdi-weather-sunny</v-icon>
            <v-icon v-if="weatherData.visibility === 'MODERATE'" :size="iconSize" class="pb-1">mdi-weather-cloudy</v-icon>
            <v-icon v-if="weatherData.visibility === 'FOG'" :size="iconSize" class="pb-1">mdi-weather-fog</v-icon>
          </div>
          <v-icon v-if="weatherData.windForce >= 4 && weatherData.windForce <= 6" :size="iconSize" class="pb-1">mdi-weather-windy-variant</v-icon>
          <v-icon v-if="weatherData.windForce >= 7 && weatherData.windForce <= 8" :size="iconSize" class="pb-1">mdi-weather-windy</v-icon>
          <v-icon v-if="weatherData.windForce >= 9" :size="iconSize" class="pb-1">mdi-weather-tornado</v-icon>
        </v-layout>
      </v-col>
    </v-row>
    <v-row v-else align="center" justify="center"><div class="text-md-body-1">No weather data available</div></v-row>
  </v-container>
</template>

<script>
import {eSailServerPublic} from "@/plugins/axios";
import moment from "moment";

export default {
  name: "WeatherForecastWidget",
  props: {
    date: null,
    challengeId: null,
    iconSize: null,
    textSize: null
  },
  data () {
    return {
      weatherData: null
    }
  },
  computed: {
    dateTimeIsNight() {
      let hour = this.date === "now" ? moment().hour() : moment(this.date).hour()
      return hour >= 21 || hour <= 6;
    }
  },
  mounted() {
    let dateParam = this.date === 'now' ? moment().toISOString() : moment(this.date).toISOString()
    let query = this.challengeId ? "/" + this.challengeId : "?date=" + dateParam
    eSailServerPublic.get('info/game/environment/weather-forecast' + query)
        .then(response => {
          let weatherData = response.data
          if (weatherData.challengeId) {
            this.weatherData = weatherData
          } else
          if (weatherData.length > 0) {
            this.weatherData = weatherData[0]
          }
        })
  }
}
</script>

<style scoped>

</style>